<template>
  <div>
    <modal-form v-model="show" size="md" :show-submit="false" @close="close(true)">
      <template v-slot:title>
        <v-icon class="mr-2">far fa-hand-point-right</v-icon> Próximos passos da Proposta -
        {{ $api.UI.Format.LeftPadNumbers(model.CodigoProposta, 9) }}
      </template>
      <template v-slot:body>
         <v-list dense class="lista-acoes">
          <v-row no-gutters v-if="(model.Situacao !== $aux.SituacaoPropostaEnum.EmDigitacao) && (model.Situacao !== $aux.SituacaoPropostaEnum.Cancelada)">
            <v-col cols="*">
              <v-list-item @click="visualizarProposta()">
                <v-list-item-icon>
                  <v-icon>far fa-file</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Resumo da Proposta</v-list-item-title>
              </v-list-item>
            </v-col>
          </v-row>

          <v-list-item @click="firmaPoderes" v-if="(model.Situacao < $aux.SituacaoPropostaEnum.Aprovada)">
            <v-list-item-icon>
              <v-icon>fas fa-file-signature</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Firmas e Poderes</v-list-item-title>
          </v-list-item>

          <v-list-item @click="validaGarantias"
            v-if="userHasRole('PropostaCancelar') && (model.Situacao === $aux.SituacaoPropostaEnum.EmDigitacao)">
            <v-list-item-icon>
              <v-icon>fas fa-share</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Enviar para Análise</v-list-item-title>
          </v-list-item>

          <v-list-item @click="cancelar"
            v-if="userHasRole('PropostaCancelar') && (model.Situacao === $aux.SituacaoPropostaEnum.EmDigitacao)">
            <v-list-item-icon>
              <v-icon>fa fa-times</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Cancelar Proposta</v-list-item-title>
          </v-list-item>

          <template>
            <AgendaParcela
              v-model="model"
              :condicaoImprimirParcelas="model.Situacao === $aux.SituacaoPropostaEnum.Aprovada || model.Situacao >= $aux.SituacaoPropostaEnum.Finalizada">
            </AgendaParcela>
            <v-list-item no-gutters v-if="model.Situacao === $aux.SituacaoPropostaEnum.Aprovada || model.Situacao >= $aux.SituacaoPropostaEnum.Finalizada"
              @click="() => $api.Multiplo.GerarCCB(model.Codigo)">
              <v-list-item-icon>
                <v-icon>fa fa-handshake</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Imprimir Contrato</v-list-item-title>
            </v-list-item>
          </template>

          <template
            v-if="model.Situacao <= $aux.SituacaoPropostaEnum.Aprovada || model.Situacao >= $aux.SituacaoPropostaEnum.Finalizada">

            <v-row no-gutters
              v-if="userHasRole('UploadDocumentoPessoa') || userHasRole('ListPessoaDocumentoByDtInclusaoProposta')">
              <v-col cols="*">
                <v-list-item :disabled="!userHasRole('UploadDocumentoPessoa')" @click="enviarDocumentoPessoa()">
                  <v-list-item-icon>
                    <v-icon>far fa-file-alt</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Documentos da Pessoa</v-list-item-title>
                </v-list-item>
              </v-col>
            </v-row>
            <v-row no-gutters
              v-if="(userHasRole('UploadDocumentoProposta') || userHasRole('ListPropostaDocumento')) && (!isCCBEletronica || hideOptionsDocsProposta)">
              <v-col cols="*">
                <v-list-item :disabled="!userHasRole('UploadDocumentoProposta')" @click="enviarDocumentoProposta([30])">
                  <v-list-item-icon>
                    <v-icon>far fa-file-alt</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Documentos da Proposta</v-list-item-title>
                </v-list-item>
              </v-col>
            </v-row>

          </template>

          <template v-if="model.Situacao === $aux.SituacaoPropostaEnum.Aprovada">
            <v-list-item v-if="userHasRole('PropostaFinalizar')" @click="finalizarProposta">
              <v-list-item-icon>
                <v-icon>fa fa-check</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Finalizar Proposta</v-list-item-title>
            </v-list-item>
            <v-row v-if="!!model.TextoMotivoAnalise">
              <v-col cols="12">
                <v-alert class="mb-1" color="warning" outlined dense text type="info">
                  Confira se o Analista solicitou algum item que ainda esteja pendente de envio
                </v-alert>
                <input-textarea readonly color="warning" v-model="model.TextoMotivoAnalise" hide-details>
                </input-textarea>
              </v-col>
            </v-row>
          </template>

          <template v-if="model.Situacao === $aux.SituacaoPropostaEnum.Finalizada && userHasRole('PropostaLiberar') && !$api.Estruturadas.isNotaComercial(model.TipoContratoSigla)">
            <template v-if="!disabledBtnLiberar[model.Cliente.TipoPessoa].includes(model.TipoContratoSigla)">
              <v-list-item v-if="userHasRole('PropostaLiberar')" @click="liberarProposta">
                <v-list-item-icon>
                  <v-icon>fa fa-check</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Liberar Proposta</v-list-item-title>
              </v-list-item>
            </template>
          </template>

          <v-list-item v-if="model.Situacao === $aux.SituacaoPropostaEnum.EmAnalise">
            <v-list-item-icon>
              <v-icon>fa fa-clock</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Aguarde a conclusão da análise</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="model.Situacao >= $aux.SituacaoPropostaEnum.Finalizada && model.Situacao < $aux.SituacaoPropostaEnum.Paga && !$api.Estruturadas.isNotaComercial(model.TipoContratoSigla)">
            <v-list-item-icon>
              <v-icon>fa fa-clock</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Aguarde o pagamento da proposta</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="model.Situacao >= $aux.SituacaoPropostaEnum.Paga && model.Situacao <= $aux.SituacaoPropostaEnum.PendentePagamento"
            @click="comprovantePagamento()">
            <v-list-item-icon>
              <v-icon>fas fa-receipt</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Comprovante de Pagamento</v-list-item-title>
          </v-list-item>

          <template v-if="model.Situacao === $aux.SituacaoPropostaEnum.Cancelada">
            <v-row>
              <v-col cols="12">
                <v-alert prominent color="warning" icon="fas fa-exclamation-triangle" text>Proposta Cancelada</v-alert>
              </v-col>
              <v-col cols="12">
                <input-textarea label="Motivo do Cancelamento" v-model="model.TextoMotivoCancelamento" rows="3"
                  disabled />
              </v-col>
            </v-row>
          </template>

          <template
            v-if="model.Situacao === $aux.SituacaoPropostaEnum.Recusada || model.Situacao === $aux.SituacaoPropostaEnum.Pendente">
            <v-list-item>
              <input-textarea label="Motivo de Rejeição" v-model="model.MotivoRejeicaoDescricao" disabled />
            </v-list-item>

            <v-list-item>
              <input-textarea label="Texto da Análise ou Pendência" v-model="model.TextoMotivoAnalise" rows="3"
                disabled />
            </v-list-item>
          </template>
        </v-list>
      </template>
    </modal-form>
    <PropostaCancelar ref="cancelar" @close="propostaCancelada" />
    <DocumentoModal ref="DocPessoa" :tipo="$aux.TipoDocumentoEntidade.Pessoa" :hasDocumentoEdit="permiteAlterarDocumentos" size="lg" :codigoPessoa="model.CodigoCliente" :codigoProposta="model.Codigo" :showOptions="permiteAlterarDocumentos"/>
    <DocumentoModal ref="DocProposta" :tipo="$aux.TipoDocumentoEntidade.Proposta" :hasDocumentoEdit="permiteAlterarDocumentos" size="lg" :codigoProposta="model.Codigo" :showOptions="permiteAlterarDocumentos"/>
    <PropostaAssinante ref="firmaPoderes" />
    <ComprovantePagamentoModal ref="comprovante" :codigoProposta="model.Codigo"></ComprovantePagamentoModal>
    <PropostaVisualizar ref="visualizar" />
  </div>
</template>
<script>
export default {
  components: {
    PropostaCancelar: () => import('./PropostaCancelar'),
    PropostaVisualizar: () => import('./PropostaVisualizar'),
    PropostaAssinante: () => import('./PropostaAssinante')

  },
  data () {
    return {
      show: false,
      model: {
        Cliente: {}
      },
      propostaSimplificada: true,
      versoesCCB: [],
      disabledBtnLiberar: {
        1: ['CPI', 'CPV'],
        2: ['CGI', 'CGV']
      }
    }
  },
  computed: {
    codigoProposta: function () {
      return this.$api.UI.Format.LeftPadNumbers(this.model.CodigoProposta, 9)
    },
    isCCBEletronica () {
      if (this.$param.EST_PRODUTOS) {
        const tiposCCB = this.$param.EST_PRODUTOS.flatMap((el) => el.Produtos.map(p => p.E))
        return tiposCCB.includes(this.model.CodigoVersaoCCB)
      }
      return false
    },
    hideOptionsDocsProposta () {
      return this.$api.Estruturadas.isNotaComercial(this.model.TipoContratoSigla) ? this.model.Situacao >= this.$aux.SituacaoPropostaEnum.Finalizada : false;
    },
    permiteAlterarDocumentos () {
      return this.model.Situacao < this.$aux.SituacaoPropostaEnum.Conferida
    }
  },
  methods: {
    openModal (sender) {
      const th = this
      th.show = true
      if (sender) {
        th.findProposta(sender.Codigo);
      }
    },
    findProposta (codigoProposta) {
      const th = this;
      th.$api.Multiplo.Post('FindRecordProposta', { guidID: codigoProposta }).then(function (proposta) {
        if (th.$api.UI.PostLoadData(proposta)) {
          proposta.Cliente = Object.assign(th.model.Cliente, proposta.Cliente)
          th.$api.UTIL.Functions.SetAllButNull(th, th, 'model', proposta)
          th.$set(th.model, 'CodigoOperacao', th.$api.UI.Guid.New())
          th.$set(th.model, 'Produto', th.$api.Estruturadas.TipoContrato.find(p => p.value === proposta.TipoContratoSigla))
          th.$api.Estruturadas.ListPropostaCampoAuxiliar(th, th.model.Codigo)
        }
      })
    },
    cancelar (e) {
      e.preventDefault()
      this.$refs.cancelar.openModal(this.model)
    },
    imprimirNotaPromissoria () {
      if (this.propostaSimplificada) { window.open(`${process.env.VUE_APP_ROOT_REPORT}imprimirnotapromissoriacesimples.aspx?code=${this.model.Codigo}`); } else { window.open(`${process.env.VUE_APP_ROOT_REPORT}imprimirnotapromissoriace.aspx?code=${this.model.Codigo}`); }
    },
    enviarDocumentoPessoa () {
      this.$refs.DocPessoa.openModal(this.model)
    },
    verDocumentoPessoa () {
      this.$refs.documento.openModal(this.model)
    },
    enviarDocumentoProposta (tipos) {
      this.$refs.DocProposta.openModal(this.model, tipos)
    },
    verDocumentoProposta (e) {
      e.preventDefault()
      this.$refs.documentoProposta.openModal(this.model)
    },
    visualizarProposta () {
      this.$refs.visualizar.openModal(this.model)
    },
    firmaPoderes () {
      this.$refs.firmaPoderes.openModal(this.model)
    },
    finalizarProposta () {
      const th = this
      th.$api.UI.Confirmacao('alerta', 'Deseja finalizar a proposta?', function () {
        const obj = {
          dto: { CodigoProposta: th.model.Codigo },
          parametros: [
            { Nome: 'IP_ADDRESS', Valor: '192.168.0.100' }
          ]
        }
        if (th.isCCBEletronica) {
          th.$api.Multiplo.Post('PropostaFinalizar', obj).then(function (response) {
            if (th.$api.UI.PostAction(response, 'Proposta Finalizada.')) {
              th.close(response)
            }
          })
        } else {
          th.$api.Multiplo.Post('FinalizaAssinaturaCCB', { guidID: th.model.Codigo }).then(function (response) {
            if (th.$api.UI.PostLoadData(response, true)) {
              th.$api.Multiplo.Post('PropostaFinalizar', obj).then(function (response) {
                if (th.$api.UI.PostAction(response, 'Proposta Finalizada.')) {
                  th.close(response)
                }
              })
            }
          })
        }
      })
    },
    liberarProposta () {
      const th = this
      th.$api.UI.Confirmacao('alerta', 'Deseja liberar a proposta?', function () {
        const obj = {
          dto: { CodigoProposta: th.model.Codigo },
          parametros: [
            { Nome: 'IP_ADDRESS', Valor: '192.168.0.100' }
          ]
        }
        th.$api.Multiplo.Post('PropostaLiberar', obj).then(function (response) {
          if (th.$api.UI.PostAction(response, 'Proposta Liberada.')) {
            th.close(response)
          }
        })
      })
    },
    validaParticipantes () {
      const th = this
      if (th.model.Cliente.TipoPessoa === th.$aux.TipoPessoaEnum.PJ) {
        var dto = {
          parameters: [
            { name: 'CodigoProposta', value: th.model.Codigo },
            { name: 'search', value: '' },
          ],
        }
        th.$api.Multiplo.Post('ListCCBDigitalAssinatura', dto).then(function (assinantes) {
          if (th.$api.UI.PostLoadData(assinantes, true)) {
            const dto = { parameters: [{ name: 'CodigoProposta', value: th.model.Codigo }] }
            th.$api.Multiplo.Post('CarregarPropostaParticipantes', dto).then(function (participantes) {
              if (th.$api.UI.PostLoadData(participantes, true)) {
                if (!assinantes.Data.some(p => p.Descricao.includes('EMITENTE') || p.PapelID === 1)) {
                  th.$api.UI.ShowError(th.$getErrorMessage('form').title, 'Ao menos um assinante deve ser responsável pela assinatura do emitente. Para isto, aqui em firmas e poderes, um dos assinantes deve ser selecionado com o papel “emitente”.')
                } else {
                  th.validaProprietarios()
                }
              }
            })
          }
        })
      } else {
        const dtoParticipantes = {
          parameters: [
            { name: 'CodigoProposta', value: th.model.Codigo }
          ]
        }
        th.$api.Multiplo.Post('ListPropostaAvalista', dtoParticipantes).then(function (listAvalistas) {
          if (th.$api.UI.PostLoadData(listAvalistas, true)) {
            const responseAvalista = listAvalistas.Data
            if (th.model.Cliente.TipoPessoa === th.$aux.TipoPessoaEnum.PJ && responseAvalista.length === 0) {
              th.$api.UI.ShowError(th.$getErrorMessage('form').title, th.$getErrorMessage('avalista').message)
            } else {
              th.validaProprietarios()
            }
          }
        })
      }
    },
    validaProprietarios () {
      const th = this
      const dto = { parameters: [{ name: 'CodigoProposta', value: th.model.Codigo }] }
      th.$api.Multiplo.Post('ListPropostaGarantiaBem', dto).then(function (listaGarantias) {
        if (th.$api.UI.PostLoadData(listaGarantias, true)) {
          if (listaGarantias.Count > 0) {
            th.$api.Multiplo.Post('ListCCBDigitalAssinatura', dto).then(function (assinantes) {
              if (th.$api.UI.PostLoadData(listaGarantias, true)) {
                if (assinantes.Count === 0) {
                  th.$api.UI.ShowError(th.$getErrorMessage('form').title, 'Não há assinantes cadastrados para a proposta')
                } else {
                  const garantiasComProprietario = listaGarantias.Data.filter(p => p.DocumentoFederalProprietario !== null)
                  const garantiasComProprietarioPJ = []
                  const garantiasComProprietarioPF = []
                  const semProprietarioAssinante = []
                  garantiasComProprietario.forEach(garantia => {
                    th.$api.UI.Format.SomenteNumeros(garantia.DocumentoFederalProprietario).length === 14 ? garantiasComProprietarioPJ.push(garantia) : garantiasComProprietarioPF.push(garantia)
                  })
                  if (garantiasComProprietarioPF.length > 0) {
                    garantiasComProprietarioPF.forEach(garantiaPF => {
                      if (!assinantes.Data.find(l => th.$api.UI.Format.SomenteNumeros(l.Documento) === th.$api.UI.Format.SomenteNumeros(garantiaPF.DocumentoFederalProprietario)) && garantiaPF.DocumentoFederalProprietario !== th.model.Cliente.DocumentoFederal) {
                        semProprietarioAssinante.push(garantiaPF)
                      }
                    })
                  }
                  if (garantiasComProprietarioPJ.length > 0) {
                    garantiasComProprietarioPJ.forEach(garantiaPJ => {
                      if (!assinantes.Data.find(assinante => assinante.Descricao.includes(garantiaPJ.DocumentoFederalProprietario))) {
                        semProprietarioAssinante.push(garantiaPJ)
                      }
                    })
                  }
                  if (semProprietarioAssinante.length > 0) {
                    th.$api.UI.ShowError(th.$getErrorMessage('form').title, 'Todos os Proprietários de Garantias devem estar cadastrados como assinantes da Proposta')
                  } else {
                    th.enviarAnalise()
                  }
                }
              }
            })
          } else {
            th.enviarAnalise()
          }
        }
      })
    },
    enviarAnalise () {
      const th = this
      const obj = {
        dto: {
          CodigoProposta: th.model.Codigo
        }
      }
      th.$api.UI.Confirmacao('alerta', 'Deseja enviar para análise?', async function () {
        // VlrRegistro - Necessário Garantir que o valor do registro está correto antes de enviar para análise
        var proposta = await th.$api.Multiplo.Post('FindRecordProposta', { guidID: th.model.Codigo })
        if (th.$api.UI.PostLoadData(proposta, true)) {
          await th.$api.Estruturadas.GetValorRegistro(th, th.model)
          var propostaSalva = true
          if ((th.model.VlrRegistro || 0).toFixed(2) !== (proposta.VlrRegistro || 0).toFixed(2)) {
            proposta.VlrRegistro = th.model.VlrRegistro
            proposta.UsarJurosProposta = true
            proposta.ByPassSituacaoOnSave = true
            proposta.PropostaValorSobreposto = {
              VlrTAC: th.model.VlrTAC,
              VlrAvaliacao: th.model.VlrAvaliacao,
              VlrIOF: th.$api.Estruturadas.isNotaComercial(th.model.TipoContratoSigla) ? 0.001 : th.model.VlrIOF
            }
            propostaSalva = await th.$api.Multiplo.Post('SaveProposta', { dto: proposta })
          }
          // -- fim VlrRegistro

          if (th.$api.UI.PostLoadData(propostaSalva, true)) {
            th.$api.Multiplo.Post('EnviarPropostaAnalise', obj).then(response => {
              if (th.$api.UI.PostLoadData(response, true)) {
                th.$api.UI.ShowSuccess('Sucesso', 'Proposta enviada para análise com sucesso!')
                th.close('lista')
              }
            })
          }
        }
      })
    },
    validaGarantias () {
      const th = this
      if (th.model.TipoOperacaoCred === 1) {
        const dto = { parameters: [{ name: 'CodigoProposta', value: th.model.Codigo }] }
        th.$api.Multiplo.Post('ListPropostaGarantiaBem', dto).then(function (response) {
          if (th.$api.UI.PostLoadData(response, true)) {
            if (response.Count <= 0) {
              th.$api.UI.ShowError('Operação não permitida', th.$getErrorMessage('garantia').message)
            } else {
              th.validaParticipantes()
            }
          }
        })
      } else {
        th.validaParticipantes()
      }
    },
    close (response) {
      this.show = false
      this.$emit('close', response)
    },
    propostaCancelada (response) {
      const th = this;
      if (response) {
        th.findProposta(th.model.Codigo)
      }
    },
    comprovantePagamento () {
      this.$refs.comprovante.openModal()
    }
  },
  mounted () {
    const th = this
    th.$api.Multiplo.Post('ListVersaoCCB', {}).then(function (response) {
      if (th.$api.UI.PostLoadData(response)) {
        th.versoesCCB = response.map(p => {
          return {
            value: p.CodigoVersao,
            text: th.$api.UI.Format.LeftPadNumbers(p.CodigoVersao, 7) + (p.DescricaoBMP ? ' - ' + p.DescricaoBMP : '')
          }
        })
      }
    })
  }
}
</script>

<style>
.lista-acoes .v-list-item__icon {
  width: 10px;
}
</style>
